import React, { PureComponent } from 'react'
import { connect } from 'react-redux';
import { Table, Button, Progress, Icon, Spin } from 'antd';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import _get from 'lodash/get';

import { getJob } from '../../common/fetch';
import ConstantAction from '../../actions/ConstantAction';
import SetupActions from '../../actions/SetupAction'
import { EventWrapper } from "./style";
import { CLOUD_EVENT_FAILED, EVENT_LOADING, FINAL_STATE_GIF, BACKUPEVENT_GIF } from '../../config/media';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import {
    defaultLoading,
} from './Utils';
import { Rive } from '../RiveComponent';
import SetupEmailSuccess from './SetupEmailSuccess';

const getColumns = (expandedKeys, updateExpand = () => { }, isView = false, currentID = 0, progressPercentage = 0, isEventStart = false) => [
    {
        title: 'Type',
        key: 'type',
        render: (data) => {
            if (progressPercentage !== 100 && (data.status === 1 || data.status === 0 || data.id === currentID)) {
                return <div className='d-flex expand-icon-container'>
                   {expandedKeys.includes(data.id)
                        ? <MinusOutlined onClick={() => updateExpand(data)} />
                        : <PlusOutlined onClick={() => updateExpand(data)} />
                    }<div className='ml-2 text-capitalize'>{data.type}</div>
                </div>
            } else {
                return <div className='text-capitalize'>{data.type}</div>;
            }
        }
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status, data) => {
            if (status === 1 || (status === 2 && progressPercentage < 99 && expandedKeys.includes(data.id))) {
                return <div className='d-flex'>
                    <img src={EVENT_LOADING} alt="icon" className="loading-image" />
                    <div className='ml-2'>In Progress... (<span className='anchor' onClick={() => updateExpand(data)}>{expandedKeys.includes(data.id) ? 'View less' : 'View more'}</span>)</div>
                </div>
            }
            switch (status) {
                case -1:
                    if (currentID === 0) {
                        return <div className='ml-2'>Sorry we've hit a snag!
                            <span>{' '}</span>
                            <span className='anchor' onClick={() => updateExpand(data)}>{data.id === currentID ? expandedKeys.includes(data.id) ? '(View less)' : '(View more)' : ''}</span>
                        </div>
                    } else {
                        return <div className='ml-2'>Failed</div>
                    }
                case 2:
                    return <div className='success-text-container'>
                        <div className='ml-2'><Icon className='status-success-icon' type="check" /> Success <span>{' '}</span>
                        </div>
                    </div>
                default:
                    return <div className='ml-2 d-flex'>
                        <img src={EVENT_LOADING} alt="icon" className="loading-image" />
                        <div className='ml-2'>In queue (<span className='anchor' onClick={() => updateExpand(data)}>{expandedKeys.includes(data.id) ? 'View less' : 'View more'}</span>)</div>
                    </div>
            }
        }
    },
    {
        title: 'Time',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (created_at) => {
            return moment(created_at).format('YYYY/MM/DD hh:mm A')
        }
    },
];

let startTime;
let elapsedTime = 0;
let timerInterval;
class Events extends PureComponent {
    constructor() {
        super();
        this.state = {
            currentTablePage: 1,
            page: 1,
            limit: 50,
            loading: false,
            expandedKeys: [],
            currentObj: {},
            isView: false,
            currentID: 0,
            expandAreaLoading: false,
            count: 0,
            eventStatus: 0,
            preEventStatus: 0,
            isQuickCompleteEvent: false,
            isQuickCompleteProgressPercentage: 0,
            isEventStart: localStorage.getItem("isEventStart") ? localStorage.getItem("isEventStart") : false,
        }
        this.handleIntervalBackupLogs = null;
        this.progressPercentage = 0;
        this.startTime = 0;
        this.timerInterval = null;
        this.handleUpdatedInterval = null;
        this.firstProgressValue = null;
        this.isUpdate = false;
    }

    componentDidMount() {
        this.getJob(this.state.page, this.state.limit, 'initial');
        this.timer = setInterval(() => {
            this.getJob(this.state.page, this.state.limit, 'initial');
        }, 2000);
        this.setState({ currentObj: defaultLoading, expandAreaLoading: true });
    }

    componentDidUpdate(prevProps, prevState) {
        const { jobStatus, jobType } = this.props.eventUtils;
        const { eventStatus, preEventStatus, isQuickCompleteEvent, count, isEventStart } = this.state;

        if (!localStorage.getItem("isEventStart")) {
            localStorage.removeItem("startTime");
        }

        if (jobStatus === 2 && prevState.eventStatus === 0) {
            this.setState({ isQuickCompleteEvent: true })
        }
        if (prevProps.eventUtils.jobStatus !== jobStatus) {
            this.updateStatus();
        }
        if (jobStatus !== 0) {
            this.setState({ eventStatus: typeof (jobStatus) === 'undefined' ? 0 : jobStatus });
            this.setState({ preEventStatus: prevState.eventStatus });
        }
        if (jobStatus === 2 && !isQuickCompleteEvent && this.progressPercentage >= 99) {
            elapsedTime = 0;
        }

        if (jobStatus === 2 && count <= 100) {
            if (eventStatus === 2 && preEventStatus === 0 && isEventStart) {
                if (count === 0) {
                    this.handleIntervalBackupLogs = setInterval(() => {
                        this.setState(prevState => (prevState.count < 100 ? { count: prevState.count + 1 } : { count: prevState.count }));
                    }, 80)
                }
                if (!isQuickCompleteEvent && count >= 100) {
                    clearInterval(this.handleIntervalBackupLogs);
                }
            }
            if (isQuickCompleteEvent && count >= 100) {
                this.setState({ isQuickCompleteEvent: false });
            }
            if (eventStatus === 2 && preEventStatus === 1 && this.progressPercentage < 99) {
                if (!this.isUpdate) {
                    this.firstProgressValue = this.progressPercentage;
                    this.setState({ isQuickCompleteProgressPercentage: this.progressPercentage })
                    this.isUpdate = true;
                }
                if (this.firstProgressValue === this.progressPercentage) {
                    this.handleUpdatedInterval = setInterval(() => {
                        this.setState(prevState => (prevState.isQuickCompleteProgressPercentage < 100 ? { isQuickCompleteProgressPercentage: prevState.isQuickCompleteProgressPercentage + 1 } : { isQuickCompleteProgressPercentage: prevState.isQuickCompleteProgressPercentage }));
                    }, 80)
                }
                if (!isQuickCompleteEvent && this.progressPercentage === 100) {
                    clearInterval(this.handleUpdatedInterval);
                }
            }
        }

        if (prevProps.eventUtils.jobStatus !== jobStatus && (jobStatus === 2 || jobStatus === -1)) {
            clearInterval(this.timer);
            clearInterval(this.processTimer);
            if (jobType && (jobType === 'start' || jobType === 'stop')) {
                this.props.getExchange();
            }
            if (jobStatus === 1 && jobType === "setEmail") {
                this.props.updateEmailSetup({ success: false, show: true })
            }
            if (jobStatus === 2 && jobType === "setEmail") {
                this.props.updateEmailSetup({ EMAIL_SETUP: { success: true, show: true, complete: true } })
            }
        }
    }

    getJob = async (page = 1, limit = 50, type = '') => {
        const { exchange, eventUtils } = this.props
        if (type && type === 'refresh') {
            this.setState({ loading: true });
        }
        try {
            const res = await
                getJob(exchange.id, {
                    limit,
                    page
                });
            if (res.data) {
                if (page === 1) {
                    if (res.data.data) {
                        let loadingImageArr = [];
                        const resultData = _get(res, 'data.data[0]');
                        const jobStatus = _get(resultData, 'status');
                        const jobType = _get(resultData, 'type');
                        const onHandleInProgressAnimation = (jobType) => {
                            if (jobType === 'GetExchangeLogs' || jobType === 'GetExchangeDatabaseBackup') {
                                return 'backupLog.riv'
                            } else if (jobType === 'setEmail') {
                                return 'updateEmail.riv'
                            } else if (jobType === 'updateDomain') {
                                return 'updateDomain.riv'
                            } else if (jobType === 'restart' || jobType === 'Terminate') {
                                return 'restart.riv'
                            } else if (jobType === 'start') {
                                return 'start.riv'
                            } else if (jobType === 'stop') {
                                return 'stop.riv'
                            } else if (jobType === 'upgrade') {
                                return 'upgrade.riv'
                            } else if (jobType === 'Setup') {
                                return 'goLive.riv'
                            }
                        }
                        const eventsGifs = [
                            { name: 'processing_1', image: onHandleInProgressAnimation(jobType), time: 1000, interval: 10, level: 1, nextLevel: 2 },
                            { name: 'success', image: FINAL_STATE_GIF, time: null, level: 3 },
                            { name: 'failed', image: CLOUD_EVENT_FAILED, time: null, level: 3 },
                        ]
                        if (jobStatus === 2 && this.state.expandedKeys.length === 0) {
                            clearInterval(timerInterval);
                            localStorage.removeItem("startTime");
                            localStorage.removeItem("isEventStart");
                        }
                        if (jobStatus === 0) {
                            loadingImageArr = [defaultLoading];
                            this.props.readEventData({ events: res.data.data, eventUtils: { ...eventUtils, loadingImageArr, jobType, jobStatus: 0 } });
                            this.setState({ expandedKeys: [resultData.id], isView: true, currentID: resultData.id });
                        } else {
                            this.setState({ isView: false });
                        }
                        if (resultData && !this.state.isView && (type === 'initial' && jobStatus !== 2)) {
                            loadingImageArr = eventsGifs;
                            if (jobType === 'GetExchangeLogs' || jobType === 'GetExchangeDatabaseBackup' || jobType === 'setEmail') {
                                loadingImageArr[0].interval = 60;
                            } else if (jobType === 'updateDomain') {
                                loadingImageArr[0].interval = 600;
                            } else if (jobType === 'restart' || jobType === 'Terminate') {
                                loadingImageArr[0].interval = 150;
                            } else if (jobType === 'start' || jobType === 'stop') {
                                loadingImageArr[0].interval = 90;
                            } else if (jobType === 'upgrade') {
                                loadingImageArr[0].interval = 1200;
                            } else if (jobType === 'Setup') {
                                loadingImageArr[0].interval = 1800;
                            }
                            this.props.readEventData({ events: res.data.data, eventUtils: { ...eventUtils, loadingImageArr, jobType, jobStatus: 1 } });
                            this.setState({ expandedKeys: [resultData.id], isView: false, currentID: resultData.id });
                        } else {
                            if (jobStatus === 2) {
                                loadingImageArr = eventsGifs
                            }
                            this.props.readEventData({ events: res.data.data, eventUtils: { ...eventUtils, loadingImageArr, jobStatus } });
                        }
                    }
                } else {
                    this.props.eventUtils(res.data.data);
                }
            }
            if (type && type === 'refresh') {
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error(error);
            if (type && type === 'refresh') {
                this.setState({ loading: false });
            }
        }
    };

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.props.readEventData({ eventUtils: { jobStatus: 0 } });
    }

    handleInterval = (nextVal = {}, skip = false) => {
        clearInterval(this.processTimer);
        let currentObjData = skip ? nextVal : this.getData(`processing_1`);
        if (!skip) {
            this.setState({ currentObj: currentObjData });
        }
        if (currentObjData && currentObjData.time) {
            this.processTimer = setInterval(() => {
                this.handleInterval(currentObjData);
            }, currentObjData.time);
        }
    }

    getData = (name) => {
        const { loadingImageArr } = this.props && this.props.eventUtils;
        return loadingImageArr && loadingImageArr.filter(i => i.name === name)[0];
    }

    handleTimer = () => {
        startTime = localStorage.getItem("startTime") ? localStorage.getItem("startTime") : Date.now() - elapsedTime;
        timerInterval = setInterval(() => {
            var currentTime = Date.now();
            elapsedTime = currentTime - startTime;
            localStorage.setItem("startTime", startTime);
        }, 10);
    }

    updateStatus = () => {
        const { jobStatus } = this.props && this.props.eventUtils;
        const { preEventStatus, isEventStart } = this.state;
        if (localStorage.getItem("isEventStart") && ((jobStatus && jobStatus === 1) || (preEventStatus === 0 && jobStatus && jobStatus === 2 && isEventStart))) {
            let currentObjData = this.getData('processing_1');
            this.setState({ currentObj: currentObjData });
            this.handleInterval(currentObjData, true);
            this.handleTimer();
        }
    }

    pageChange = (count, pageSize) => {
        const { page, limit, isRemaining } = this.state;
        const pageCount = count % 5 === 0 ? 5 : count % 5;
        const apiPageTemp = Math.floor(count / 5);
        if (limit === pageSize * pageCount && apiPageTemp >= page && isRemaining) {
            this.getJob(
                page + 1,
                limit
            );
        }
        this.setState({ currentTablePage: count });
    }

    handleRefresh = () => {
        this.getJob(this.state.page, this.state.limit, 'refresh');
        this.setState({ currentState: !this.state.currentState })
    };

    updateExpand = (data, record) => {
        const { expandedKeys } = this.state;
        let expandId = record && record.id ? record.id : data.id;

        if (!expandedKeys.includes(expandId)) {
            this.setState({ expandedKeys: [...expandedKeys, expandId], isView: true })
        } else if (expandedKeys.includes(expandId)) {
            let index = expandedKeys.indexOf(expandId)
            expandedKeys.splice(index, 1);
            this.setState({ expandedKeys, isView: true, currentID: 0 })
        }
    }

    handleExpand = (data) => {
        const { isQuickCompleteEvent, eventStatus, preEventStatus, count, isQuickCompleteProgressPercentage } = this.state;
        let currentObjData = ((data.status === 2 && preEventStatus === 1 && this.progressPercentage === 100) || (data.status === 2 && preEventStatus === 0 && this.progressPercentage === 100)) ? this.getData('success') : (data.status === -1) ? this.getData('failed') : ((data.status === 1) || (data.status === 2 && isQuickCompleteEvent)) ? this.getData('processing_1') : this.state.currentObj;
        let percentageKey = currentObjData && currentObjData.interval / 100;
        this.progressPercentage = (data.status === 2 && isQuickCompleteEvent) ? count : (data.status === 2 && !isQuickCompleteEvent && this.progressPercentage === 100) ? 100 : isQuickCompleteProgressPercentage !== 0 ? isQuickCompleteProgressPercentage : Number(JSON.stringify(elapsedTime / (percentageKey * 1000)).split(".")[0]);
        if (eventStatus === 1 && ((elapsedTime > (currentObjData && currentObjData.interval * 1000) - 2000))) {
            this.progressPercentage = 99;
            clearInterval(timerInterval);
        }
        if ((data.status === 2 && !isQuickCompleteEvent && this.progressPercentage === 100) || (data.status === 2 && preEventStatus === 1 && this.progressPercentage === 99)) {
            this.progressPercentage = 100;
            clearInterval(timerInterval);
            elapsedTime = 0;
            localStorage.removeItem("startTime");
            currentObjData = this.getData('success');
            localStorage.removeItem("isEventStart");
        }
        if (this.state.expandAreaLoading) {
            setTimeout(() => {
                this.setState({ expandAreaLoading: false });
            }, 50);
        }
        if (data.status === -1) {
            clearInterval(timerInterval);
            elapsedTime = 0;
            localStorage.removeItem("startTime");
            localStorage.removeItem("isEventStart");
            return (
                <div className='fail-container'>
                    <div className='fail-img' style={{ backgroundImage: `url(${CLOUD_EVENT_FAILED})` }}></div>
                    <div className='fail-content'>
                        <div>It seems we've ran into some unexpected problem.</div>
                        <div>Please try again, or if it is a persistent problem</div>
                        <div>then reach out to support.</div>
                    </div>
                    <div className='failed-content'>
                        We thank you for your patience.
                    </div>
                </div>
            )
        } else if (currentObjData && currentObjData.image) {
            return (
                <div className='td-cell-container'>
                    {this.state.expandAreaLoading ? <Spin></Spin>
                        : <div className='cell-container'>
                            {(data.status !== 0 && this.progressPercentage !== 100) ?
                                <div className='rive-animation'>
                                    {currentObjData && currentObjData.image === "backupLog.riv" ?
                                        <img className='backup-gif' src={BACKUPEVENT_GIF} alt="domain" />
                                        : <Rive src={currentObjData.image} />}
                                </div>
                                : <div className='fail-img' style={{ backgroundImage: `url(${currentObjData && currentObjData.image})` }}></div>}
                            {data.status !== 0 && <div className='width-40 d-flex'>
                                <Progress percent={this.progressPercentage} showInfo={false} />
                                <div className='progress-percentage-wrapper'>
                                    <span>{
                                        this.progressPercentage === 100 ? <span className='check-icon-container'><Icon type="check" /></span> :
                                            data.status === 1 || (data.status === 2 && isQuickCompleteEvent) || (data.status === 2 && preEventStatus === 1 && this.progressPercentage <= 99) ? `${this.progressPercentage}%` : isQuickCompleteProgressPercentage !== 0 ? `${isQuickCompleteProgressPercentage}%` : null}</span>
                                </div>
                            </div>}
                        </div>}
                </div>
            )
        }
    }

    render() {
        const { currentTablePage, loading, expandedKeys, isView, currentID } = this.state;
        const { events = [] } = this.props;
        return (
            <EventWrapper>
                <div className="main-content">
                    <div>
                        <div className="main-title">
                            Cloud hosting event log
                        </div>
                        <div>
                            Below is a table of all your exchange cloud hosting events
                        </div>
                    </div>
                    <Button type="primary" onClick={this.handleRefresh} >Refresh</Button>
                </div>
                <div className="table-wrapper expanded-row-events-bg">
                    <Table
                        columns={getColumns(expandedKeys, this.updateExpand, isView, currentID, this.progressPercentage)}
                        rowKey={(data) => data.id}
                        dataSource={events}
                        loading={loading}
                        pagination={{
                            current: currentTablePage,
                            onChange: this.pageChange
                        }}
                        expandedRowKeys={expandedKeys}
                        expandedRowRender={(data) => this.handleExpand(data)}
                        onExpand={(data, index) => this.updateExpand(data, index)}
                        expandIconAsCell={false}
                        expandIconColumnIndex={-1}
                    />
                </div>
                <SetupEmailSuccess />
            </EventWrapper>
        )
    }
}

const mapStateToProps = (state) => ({
    exchange: state.exchange[0] || {},
    events: state.constant.events,
    eventUtils: state.constant.eventUtils,
    emailSetup: state.setup.EMAIL_SETUP
});

const mapDispatchToProps = (dispatch) => ({
    readEventData: bindActionCreators(ConstantAction.readEventData, dispatch),
    updateEventData: bindActionCreators(ConstantAction.updateEventData, dispatch),
    updateEmailSetup: bindActionCreators(SetupActions.updateEmailSetup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Events);